import { render } from "./CarrosselSlides.vue?vue&type=template&id=60eec9a6&scoped=true"
import script from "./CarrosselSlides.vue?vue&type=script&lang=js"
export * from "./CarrosselSlides.vue?vue&type=script&lang=js"

import "./CarrosselSlides.vue?vue&type=style&index=0&id=60eec9a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60eec9a6"]])

export default __exports__